import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import ReviewBanner from '../components/home/ReviewBanner';
import GoogleReviewsSection from '../components/home/GoogleReviewsSection';
import MissionSection from '../components/home/MissionSection';
import ServicesSection from '../components/home/ServicesSection';
import RecentProjectsSection from '../components/home/RecentProjectsSection';
import WhyUsSection from '../components/home/WhyUsSection';
import AccreditationsSection from '../components/home/AccreditationsSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Solar, Battery, Heat Pump &amp; Electrification Australia"
        description="Supa Energy Hub — Australian solar, battery, heat pump hot water, EV charging and electrification. Honest advice, quality installs, the Supa Promise and the Supa Value Guarantee."
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Supa Energy Hub',
            url: 'https://supaenergyhub.com.au',
            logo: 'https://supaenergyhub.com.au/logo.png',
            slogan: 'Same Products. Better Value. Superior Service.',
            description:
              'Australian solar, battery, heat pump hot water, EV charging and electrification specialist.',
            areaServed: { '@type': 'Country', name: 'Australia' },
            email: 'info@supaenergyhub.com.au',
          },
        ]}
      />
      <Header />
      <main>
        <HeroSection />
        <ReviewBanner />
        <GoogleReviewsSection />
        <MissionSection />
        <ServicesSection />
        <RecentProjectsSection />
        <WhyUsSection />
        <AccreditationsSection />
        <HowItWorksSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
